import styled from 'styled-components';

import { NeutralColors } from '@/theme';

export const Label = styled.span`
  color: ${NeutralColors[10]};
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin: 0 12px;
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    color: ${NeutralColors[60]};
    transition: color 0.3s ease-in-out;

    &:hover {
      color: ${NeutralColors[0]};
    }
  }
`;
